export { EduArticlePage as default } from 'processes/EduHub/EduArticlePage/EduArticlePage';
export { getStaticPaths } from 'processes/EduHub/EduArticlePage/getStaticPaths';
export { getStaticProps } from 'processes/EduHub/EduArticlePage/getStaticProps';
